import axios from 'axios'
import { API_URL } from '@/const'
import { store } from '@/store'

export const postAxiosParticipant = (channel, { email, fullname, username }) => {
  const user = { email, fullname, username }
  const { accessToken } = store.state.app.user
  const headers = {
    Authorization: `Bearer ${accessToken}`
  }
  axios
    .post(`${API_URL.PARTICIPANTS_V1}/${channel}`, user, { headers })
    .then(() => {})
    .catch((err) => console.log(err.response.data))
}
